import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'company-link-icon-svg',
  template: `
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Shape</title>
      <g id="Create-Account-with-Commercial" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Create-Account-commercial-link" transform="translate(-326.000000, -702.000000)" fill="#006580" fill-rule="nonzero">
              <g id="np_commercial-building_2205663_006580" transform="translate(326.000000, 702.000000)">
                  <path d="M22.3709333,12 L16.4448,12 L16.4448,0.148 L1.62906667,0.148 L1.62906667,20.8885333 L0.147813333,20.8885333 L0.147813333,23.8509333 L23.85208,23.8519749 L23.85208,20.8895749 L22.3708267,20.8885331 L22.3709333,12 Z M4.5928,3.11146667 L7.5552,3.11146667 L7.5552,6.07386667 L4.5928,6.07386667 L4.5928,3.11146667 Z M4.5928,9.0376 L7.5552,9.0376 L7.5552,12 L4.5928,12 L4.5928,9.0376 Z M12,20.8885333 L6.07386667,20.8885333 L6.07386667,14.9624 L12,14.9624 L12,20.8885333 Z M13.4812533,12 L10.5188533,12 L10.5188533,9.0376 L13.4812533,9.0376 L13.4812533,12 Z M13.4812533,6.07386667 L10.5188533,6.07386667 L10.5188533,3.11146667 L13.4812533,3.11146667 L13.4812533,6.07386667 Z M20.8884533,17.9258667 L17.9260533,17.9258667 L17.9260533,14.9634667 L20.8884533,14.9634667 L20.8884533,17.9258667 Z" id="Shape"></path>
              </g>
          </g>
      </g>
    </svg>
  `
})
export class CompanyLinkIconSvgComponent {


}
